import { useRequiredContext } from "@redotech/react-util/context";
import { AuthContext } from "@redotech/redo-merchant-app-common/auth";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { memo } from "react";
import { useReturnsOnboardingResumeState } from "../../onboarding/returns-onboarding-resume-state";
import { visibleReturnsOnboardingResumeState } from "../../onboarding/returns-onboarding-resume-visibility";
import * as notificationCss from "./notification.module.css";
import { ActionRequiredBanner } from "./notifications/action-required-notification";
import { HolidaySurchargesBanner } from "./notifications/holiday-surcharges-banner";
import { IncidentsBanner } from "./notifications/incident-banner";
import { OmsExpertHelpBanner } from "./notifications/oms-expert-help-banner";
import { ReturnsOnboardingResumeBanner } from "./notifications/returns-onboarding-resume-banner";
import { ReturnsSettingsExperienceBanner } from "./notifications/returns-settings-experience-banner";
import { UspsHazmatFeeBanner } from "./notifications/usps-hazmat-fee-banner";

/**
 * TODO: Refactor this to use a new notification system
 */
export const NotificationBanner = memo(function NotificationBanner() {
  const auth = useRequiredContext(AuthContext);
  const team = useRequiredContext(TeamContext);
  const returnsResumeStateLoad = useReturnsOnboardingResumeState();
  const returnsResumeState = visibleReturnsOnboardingResumeState({
    returnsEnabled: team.settings.returns?.enabled === true,
    state: returnsResumeStateLoad,
  });

  return (
    <div className={notificationCss.updateBanner}>
      {returnsResumeState && (
        <ReturnsOnboardingResumeBanner
          auth={auth}
          onDismiss={
            returnsResumeStateLoad.archiving
              ? undefined
              : returnsResumeStateLoad.archive
          }
          state={returnsResumeState}
          teamId={team._id}
        />
      )}
      <OmsExpertHelpBanner />
      <ReturnsSettingsExperienceBanner />
      <UspsHazmatFeeBanner />
      <HolidaySurchargesBanner />
      <ActionRequiredBanner />
      <IncidentsBanner />
    </div>
  );
});
